import React from 'react';
import '../../less/tablet';
import MenuItem from '../../views/menuItem.c';
import InsideMenuItem from '../../views/insideMenuItem.c';
import SegmentedStorybook from '@abank/abank-segmented';
import { CSSTransition } from "react-transition-group";
import LogoLink from '../../views/logoLink.c';
import { getMenuConfig } from '../../getMenuConfig.js';
import leftMenuConfig from '../../enums/tablet/left_menu_config.json';

export default function template() {
  const { navigate, activeSub, isSearchPage, homeUrl, userTypes, isBusiness, isCollapsed } = this.props;
  const { isOpen, mode } = this.state;

  const renderSubMenuItems = (items, alias) =>
    items.map(item => item.target ? (
      <MenuItem
        key={item.title}
        activeSub={activeSub}
        navigate={navigate}
        target={item.target}
        onClick={() => window.open(item.url, item.target)}
        closeMenu={this.toggleMenu}
      >
        {this.l10n(item.title)}
      </MenuItem>
    ) : (
      <MenuItem
        key={item.title}
        activeSub={activeSub}
        alias={alias}
        navigate={navigate}
        url={item.url}
        closeMenu={this.toggleMenu}
      >
        {this.l10n(item.title)}
      </MenuItem>
  ));

  const renderLeftMenu = () => {
    const menu = isBusiness ? leftMenuConfig.business : leftMenuConfig.individual;
    return menu.map(item => (
      <div className="tablet-header-menu__wrapper" key={item.alias} onClick={() => this.toggleMode(item.alias)} onKeyDown={(e) => e.key === 'Enter' && this.toggleMode(item.alias)} tabIndex="0">
        <MenuItem
          className="title"
          active={mode}
          alias={item.alias}
          navigate={navigate}
          url={item.url}
          top
          closeMenu={item.closeMenu ? this.toggleMenu : undefined}
        >
          <div>{this.l10n(item.title)}</div>
        </MenuItem>
      </div>
    ));
  };

  const menu = getMenuConfig().find(c => c.alias === mode);

  return (
    <header className={`module-header-tablet${isCollapsed ? ' collapsed' : ''}`}>
      <CSSTransition in={!isCollapsed} timeout={250} classNames="fly-user-type" unmountOnExit>
        <div className="user-type">
          <SegmentedStorybook
            collapsed={false}
            tabs={userTypes}
            tab={this.props.userType}
            toggle={this.props.changeUserType}
            leadIcon={false}
          />
        </div>
      </CSSTransition>
      <div className="tablet-header-top">
        <div className="container">
          <div className="tablet-header-top__left left-tablet-header-top">
            <LogoLink homeUrl={homeUrl} navigate={navigate} className="left-tablet-header-top__logo"/>
            <div className={`icon-menu__wrapper ${isOpen ? 'active' : ''}`} onClick={this.toggleMenu}>
              <div className={`icon-menu ${isOpen ? 'active' : ''}`}><span></span><span></span><span></span></div>
            </div>
          </div>
          {!isSearchPage && (
            <div className="tablet-header-top__right right-tablet-header-top">
              <div className="left-tablet-header-top__input">
                <input type="text" onClick={() => window.open('/search', '_self')} placeholder={this.l10n('NEW_HEADER_INPUT_PLACEHOLDER')} />
              </div>
            </div>
          )}
        </div>
      </div>
      {isOpen && (
        <div className="tablet-header-menu-wrapper">
          <div className="tablet-header-menu">
            <div className={`tablet-header-menu__left${isBusiness ? ' tablet-header-menu__left_business' : ''}`}>
              {renderLeftMenu()}
            </div>
            <div className="tablet-header-menu__right">
              <InsideMenuItem menu={menu} bannerCloseHandler={this.toggleMenu} active={mode} navigate={navigate} renderSubMenuItems={renderSubMenuItems} version="tablet"/>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
